document.addEventListener('DOMContentLoaded', function () {
  const isMobile = window.innerWidth < 750;
  const videos = document.querySelectorAll('video.autoplay, video.bg-video, video[autoplay]');

  videos.forEach(function (video) {
    // Skip autoplay for editorial videos on mobile
    if (isMobile) {
      const inEditorial = video.closest('[class*="media-with-content"]');
      if (inEditorial) {
        return;
      }
    }

    // Make absolutely sure the element is muted & inline
    try {
      video.muted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('muted', '');
    } catch (e) {}

    // Setup IntersectionObserver to play when visible
    if (typeof IntersectionObserver !== 'undefined') {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            // Video is visible, attempt to play
            var playPromise = entry.target.play();
            if (playPromise !== undefined) {
              playPromise.catch(function (err) {
                // If autoplay still blocked, try on user interaction
                function resume() {
                  entry.target.play().catch(function(){});
                  window.removeEventListener('click', resume);
                  window.removeEventListener('touchstart', resume);
                }
                window.addEventListener('click', resume, { passive: true });
                window.addEventListener('touchstart', resume, { passive: true });
              });
            }
          } else {
            // Video not visible, pause it
            entry.target.pause();
          }
        });
      }, { threshold: 0.01 });
      io.observe(video);
    } else {
      // Fallback for browsers without IntersectionObserver
      var playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(function (err) {
          function resume() {
            video.play().catch(function(){});
            window.removeEventListener('click', resume);
            window.removeEventListener('touchstart', resume);
          }
          window.addEventListener('click', resume, { passive: true });
          window.addEventListener('touchstart', resume, { passive: true });
        });
      }
    }
  });
});
